/* eslint-disable import/no-default-export */
import React from 'react';
import { connect } from 'react-redux';

import { TestId } from '@trello/webdriverio-tests';
// eslint-disable-next-line no-restricted-imports
import { State } from 'modules';
// eslint-disable-next-line no-restricted-imports
import { getBoardById, getTeamById, isBoardStarred } from 'selectors';
// eslint-disable-next-line no-restricted-imports
import { BoardModel, BoardsMenuCategoryType } from 'types/models';
import { CompactBoardTile } from './compact-board-tile';

interface OwnProps {
  readonly idBoard: string;
  readonly boardTileClassName?: string;
  readonly isDragging?: boolean;
  readonly showTeamName?: boolean;
  readonly focused?: boolean;
  readonly testId?: TestId;
  readonly type?: BoardsMenuCategoryType;
}

interface StateProps {
  readonly board: BoardModel | undefined;
  readonly isStarred: boolean;
  readonly teamName: string | undefined;
}

interface AllProps extends OwnProps, StateProps {}

class CompactBoardTileContainer extends React.Component<AllProps> {
  render() {
    const { board, ...rest } = this.props;

    return board ? <CompactBoardTile board={board} {...rest} /> : null;
  }
}

function mapStateToProps(state: State, ownProps: OwnProps): StateProps {
  const board = getBoardById(state, ownProps.idBoard);
  const team =
    board && board.idTeam ? getTeamById(state, board.idTeam) : undefined;

  return {
    board,
    isStarred: isBoardStarred(state, ownProps.idBoard),
    teamName: team ? team.displayName : undefined,
  };
}

export default connect(mapStateToProps)(CompactBoardTileContainer);



// WEBPACK FOOTER //
// ./app/gamma/src/components/compact-board-tile/index.tsx